import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container
} from 'reactstrap';
import profile from '../../assets/images/profile-img.png';
import logo from '../../fav3.0.png';
import { verifyEmailRequest } from '../../axios/admin';

const VerifyEmail = () => {
  document.title = 'Seamless Slot';
  const location = useLocation();


  const [usecase, setUsecase] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const tokenFromURL = params.get('token');
    const newEmailFromURL = params.get('newEmail');
    const userIdFromURL = params.get('userId');
    const usecaseFromURL = params.get('usecase');

    if (tokenFromURL && newEmailFromURL && userIdFromURL && usecaseFromURL) {
   

      let body = {
        newEmail: newEmailFromURL,
        token: tokenFromURL,
        userId: parseInt(userIdFromURL)
      };
      approveData(body);

      // format usecase (remove underscores, capitalize)
      const formattedUsecase = usecaseFromURL
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
      setUsecase(formattedUsecase);
    } else {
      setErrorMessage('Invalid or incomplete verification link.');
    }
  }, []);

  const approveData = async (body) => {
    try {
      let response = await verifyEmailRequest(body);
  
      if (response?.status === 200 || response?.status === 201) {

        setSuccessMessage(response?.data?.data || 'Email verified successfully.');
      } else {
        setErrorMessage(response?.data?.message || 'Verification failed.');
      }
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || 'Something went wrong while verifying.');
    }
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <div className="bg-dark-subtle">
                <Row>
                  <Col xs={7}>
                    <div className="text-dark p-4">
                      <h5 className="text-dark">
                        {usecase ? usecase : 'Email Verification'}
                      </h5>
                      <p>Please wait while we verify your request.</p>
                    </div>
                  </Col>
                  <Col className="col-5 align-self-end">
                    <img src={profile} alt="" className="img-fluid" />
                  </Col>
                </Row>
              </div>

              <CardBody className="pt-0 text-center">
                <div className="auth-logo mb-3">
                  <div className="avatar-md profile-user-wid mb-4">
                    <span className="avatar-title rounded-circle bg-light">
                      <img src={logo} alt="" className="rounded-circle" height="34" />
                    </span>
                  </div>
                </div>

                {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                {successMessage && <Alert color="success">{successMessage}</Alert>}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyEmail;
